// extracted by mini-css-extract-plugin
module.exports = {"mapIframeAnchor":"bs-lp20-src-pages-map-module-map-iframe-anchor","mapIframe":"bs-lp20-src-pages-map-module-map-iframe"};